module.exports = __webpack_public_path__ + "static/img/loginbg-old.0ba4a1cb.png";